import 'core-js/fn/promise';
import 'babel-polyfill'; // 87.7K (gzipped: 28.9K) only for IE11, please remove if we don't support IE11
import React from 'react';
import ReactDOM from 'react-dom';
import './semantic/dist/semantic.css';
import App from './App';
import { unregister } from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
unregister();



// WEBPACK FOOTER //
// ./src/index.js